import React from 'react';
import { formatTimeframeDisplay } from '@/components/shared/research-utils';

interface TimeframeDisplaySectionProps {
  parameters: Record<string, any>;
}

export const TimeframeDisplaySection: React.FC<TimeframeDisplaySectionProps> = ({ 
  parameters 
}) => {
  const hasTimeframe = !!(parameters.timeframe || parameters.timeframe_label || parameters.date_range_start);
  
  if (!hasTimeframe) return null;

  // Helper function to determine timeframe color based on end date
  const getTimeframeColor = (): string => {
    const dateRangeEnd = parameters.date_range_end;
    if (!dateRangeEnd) return 'purple';
    
    const endDate = new Date(dateRangeEnd);
    const now = new Date();
    const sixMonthsAgo = new Date(now.getTime() - (6 * 30 * 24 * 60 * 60 * 1000));
    
    return endDate >= sixMonthsAgo ? 'green' : 'red';
  };

  const timeframeColor = getTimeframeColor();

  return (
    <div className={`p-3 rounded-2xl bg-gradient-to-r ${
      timeframeColor === 'green' 
        ? 'from-green-50 to-emerald-50 dark:from-green-900/20 dark:to-emerald-900/20 border-green-200 dark:border-green-800' 
        : timeframeColor === 'red'
        ? 'from-red-50 to-rose-50 dark:from-red-900/20 dark:to-rose-900/20 border-red-200 dark:border-red-800'
        : 'from-purple-50 to-indigo-50 dark:from-purple-900/20 dark:to-indigo-900/20 border-purple-200 dark:border-purple-800'
    } border`}>
      <span className={`text-sm ${
        timeframeColor === 'green' 
          ? 'text-green-600 dark:text-green-400' 
          : timeframeColor === 'red'
          ? 'text-red-600 dark:text-red-400'
          : 'text-purple-600 dark:text-purple-400'
      }`}>
        {formatTimeframeDisplay(parameters)}
      </span>
    </div>
  );
}; 